import styles from './side-navigation-item.module.scss';


export const SideNavigationItemHidden = () => {
  return (
    <div className={styles.itemHidden} />
  )
}
